import styled from 'styled-components';
export const Flex1 = styled.div`
  flex: 1;
`;
export const BuyMilagePage = styled(Flex1)`
  display: flex;
  flex-direction: column;
`;
export const BuyMilagePageBox = styled(Flex1)`
  display: flex;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    flex-direction: column;
  }
`;
export const BuyMilagePageBoxLeft = styled(Flex1)`
  margin-inline-end: ${({ theme }) => theme.spacing.x4};
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    margin-inline-end: 0;
  }
`;
export const BuyMilagePageBoxLeftCard = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  padding: ${({ theme }) => theme.spacing.x4};
`;
export const BuyMilagePageBoxLeftTitle = styled.span`
  font-weight: 500;
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;
export const BuyMilagePageBoxLeftInput = styled.span`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const BuyMilagePageBoxInputCard = styled.div`
  background: ${({ theme }) => theme.palette.white};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
  padding: ${({ theme }) => theme.spacing.x8};
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;
export const BuyMilagePageBoxInputTitle = styled.span`
  text-align: center;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fs.md};
  margin-bottom: ${({ theme }) => theme.spacing.x8};
`;
export const BuyMilagePageBoxGrayCard = styled.div`
  margin-bottom: ${({ theme }) => `${theme.spacing.x4} ${theme.spacing.x8}`};
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  box-shadow: ${({ theme }) => theme.boxShadow.sm};
  border-radius: ${({ theme }) => theme.rounded.x3};
`;
export const BuyMilagePageBoxGrayCardRow = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const BuyMilagePageBoxGrayCardvalue = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};
`;
export const BuyMilagePageBoxGrayCardRow2 = styled(BuyMilagePageBoxGrayCardRow)`
  padding-top: ${({ theme }) => theme.spacing.x4};
`;
export const BuyMilagePageBoxGrayCardCBlue = styled.span`
  font-size: ${({ theme }) => theme.fs.xs};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.secondary};
`;
export const BuyMilagePageBoxGrayCardBtn = styled.div`
  font-size: ${({ theme }) => theme.fs.xs};

  margin-right: auto;
  margin-left: auto;

  margin-bottom: ${({ theme }) => theme.spacing.x6};
  color: ${({ theme }) => theme.palette.white};
  width: 147px;
`;
export const BuyMilagePageBoxRight = styled.div`
  width: 400px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.media.md}) {
    width: 100%;
  }
`;
